































import Vue from 'vue';
import ExplanationOfPayment from '@/components/account-components/account-eop-components/explanation-of-payment.component.vue';

import { FullscreenWrapper } from '@/components/fullscreen-wrapper-components';

import { FileUpload, CloseFullscreenWrapper, OpenHelp } from '@/mixins';
import { ClaimsPaymentResponseModel } from '@/@types/member';
import { ExtendMixins } from '@/services';

interface Params {
  transactionId: number;
  appealRightsHeadline: string;
  appealRightsContent: string;
}

export default ExtendMixins(
  FileUpload,
  CloseFullscreenWrapper,
  OpenHelp,
).extend({
  name: 'ExplanationOfPaymentOverlay',
  props: {
    params: {
      type: Object as () => Params,
      required: true,
    },
  },
  computed: {
    details(): ClaimsPaymentResponseModel {
      return this.$store.getters.eopDetails(
        this.params.transactionId.toString(),
      );
    },
  },
  components: {
    FullscreenWrapper,
    ExplanationOfPayment,
  },
});
